import { TAccount } from './accounts.types';

/**
 * Gets the offer available for drawdown from an account
 * @param account: TAccount- An Account object
 * @returns The offer object
 */
export const getInLoanDrawdownOffer = (account: TAccount) => {
    //topups are currently only one offer, so if there are more than one formal offers, we assume it's a drawdown on the current offer agreement
    let drawdownOfferId;
    const formalOffers = account.formal_offers;
    if (formalOffers.length >= 2) {
        drawdownOfferId = account?.loan_offer_id;
    } else {
        drawdownOfferId = account?.latest_formal_offer?.offer_id;
    }
    return formalOffers.find((offer) => offer.offer_id === drawdownOfferId);
};
